<!-- components/GaugeSemi.vue -->
<template>
  <div class="flex flex-col items-center w-full">
    <div v-if="title" class="text-sm text-slate-500 mb-1">{{ title }}</div>

    <svg
        class="w-full h-auto overflow-visible block"
        viewBox="0 0 200 100"
        preserveAspectRatio="xMidYMid meet"
    >
      <!-- Pista -->
      <path
          d="M10 100 A90 90 0 0 1 190 100"
          fill="none"
          :stroke="bgColor"
          :stroke-width="stroke"
          pathLength="100"
      />

      <!-- Progreso -->
      <path
          d="M10 100 A90 90 0 0 1 190 100"
          fill="none"
          :stroke="color"
          :stroke-width="stroke"
          pathLength="100"
          :stroke-dasharray="`${clamped} 100`"
      />

      <!-- % -->
      <text x="80" :y="isBig ? 100 : 120" text-anchor="middle"
            class="font-semibold" :fill="percentColor" style="font-size:22px">
        {{ clamped }}
      </text>

      <text x="115" :y="isBig ? 100 : 120" text-anchor="middle"
            class="font-semibold" fill="#949494" style="font-size:16px">
        / 100
      </text>
    </svg>
  </div>


</template>

<script>
export default {
  props: {
    value: { type: Number, required: true },     // 0..100
    title: { type: String, default: '' },
    size:  { type: Number, default: 220 },
    stroke:{ type: Number, default: 32 },        // grosor de la barra
    color: { type: String, default: '#fb6a3a' }, // color de progreso
    bgColor: { type: String, default: '#eff3f8' },
    needleColor: { type: String, default: '#6b7280' },
    isBig: { type: Boolean, default: false },

    /* Aguja más “ancha” que la barra: la línea cruza el arco con overshoot */
    needleStroke: { type: Number, default: 4 },  // grosor visual de la aguja
    overshootIn:  { type: Number, default: 3 },  // cuánto entra hacia el centro (px)
    overshootOut: { type: Number, default: 5 },  // cuánto sale hacia fuera (px)

    percentColor: { type: String, default: '#111827' }
  },
  data() {
    return {
      cx: 100,
      cy: 100,
      radius: 90
    }
  },
  computed: {
    clamped() {
      return Math.max(0, Math.min(100, Math.round(this.value)))
    },
    angleDeg() {
      return 180 + (this.clamped / 100) * 180
    },
    angleRad() {
      return this.angleDeg * Math.PI / 180
    },
    cosA() {
      return Math.cos(this.angleRad)
    },
    sinA() {
      return Math.sin(this.angleRad)
    },
    needleInner() {
      const r = this.radius - this.stroke / 2 - this.overshootIn
      return { x: this.cx + r * this.cosA, y: this.cy + r * this.sinA }
    },
    labelClass() {
      if (this.clamped < 40)  return 'text-orange-500'
      if (this.clamped < 70)  return 'text-amber-500'
      return 'text-emerald-600'
    }
  }
}



</script>
